// extracted by mini-css-extract-plugin
module.exports = {"checkItem":"CheckItem_checkItem__D_cn8","checkIcon":"CheckItem_checkIcon__a0sT_"};